import React from 'react';

export function handleKeyboardClick(
	event: React.KeyboardEvent,
	callback?: () => void,
) {
	if (event.key === 'Enter' || event.key === ' ') {
		event.preventDefault();
		if (callback) callback();
	}
}
